import { css, FlattenSimpleInterpolation } from 'styled-components';
import { stripUnit } from 'polished';

type FluidCSSProperty = (
    props: { prop: string; range: string[] },
    viewports: string[]
) => FlattenSimpleInterpolation;

const fluidCSSProperty: FluidCSSProperty = ({ prop, range }, viewports) => css`
    ${prop}: ${range[0]};

    ${viewports.map((viewport, i) => {
        if (i === viewports.length - 1)
            return css`
                @media screen and (min-width: ${viewport}) {
                    ${prop}: ${range[i]};
                }
            `;
        return css`
            @media screen and (min-width: ${viewport}) {
                ${prop}: calc( ${range[i]} + (${stripUnit(
                    range[i + 1]
                )} - ${stripUnit(
                    range[i]
                )}) * ((100vw - ${viewport}) / (${stripUnit(
                    viewports[i + 1]
                )} - ${stripUnit(viewport)})));
            }
        `;
    })}
`;

const fluidCSSPropertyHelper = ({ prop, range }) => css`
    ${({ theme }) =>
        fluidCSSProperty({ prop, range }, [
            theme.breakpoints.sm,
            theme.breakpoints.md,
            theme.breakpoints.lg,
        ])}
`;

export default fluidCSSProperty;

export { fluidCSSPropertyHelper };
